import React, { useState, useEffect } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import SupervisorApi from "../../utility/supervisorApi";
import { formatDateTime } from "../../components/formatDateTime";
import ChatDelete from "./ChatDelete";

function ChatMessages({ selectedContact, handleRefetch }) {
  const { fetchOnlyData } = SupervisorApi();
  const [messages, setMessages] = useState([]);
  const { data } = useQuery({
    queryKey: ["supervisorMessages", selectedContact],
    keepPreviousData: true,
    queryFn: () => fetchOnlyData(`chats/get/${selectedContact}`),
    enabled: !!selectedContact,
    staleTime: 3000,
    refetchInterval: 5000,
  });

  const readMessage = useMutation({
    mutationFn: (id) => fetchOnlyData(`chats/read/${id}`),
  });

  useEffect(() => {
    setMessages(data);

    // Find unread messages
    let unRead = data?.filter((item) => item?.is_read === 0);
    const unReadId = Array.isArray(unRead)
      ? unRead.map((item) => item?.id)
      : [];

    if (unReadId.length > 0) {
      // Ensure all messages are marked as read before refetching
      Promise.all(
        unReadId.map(
          (item) =>
            new Promise((resolve) => {
              readMessage.mutate(item, {
                onSettled: resolve, // Resolve promise when mutation completes
              });
            })
        )
      ).then(() => {
        handleRefetch();
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <div className="flex-1 p-2 overflow-y-auto">
      {messages?.length === 0 ? (
        <div className="w-full h-full flex flex-col justify-end items-center pb-8">
          <h3 className="text-xl font-semibold">Start a conversation!</h3>
          <h4 className="text-gray-700">You haven't sent any messages yet.</h4>
        </div>
      ) : (
        selectedContact &&
        messages?.map((message) => (
          <div
            key={message?.id}
            // className="mb-4 flex justify-between gap-1 items-center"
            className={`mb-4 flex items-center
            ${
              message?.role === "sender"
                ? "justify-end"
                : "text-left flex-row-reverse justify-end"
            }

          `}
          >
            <div
              // className="bg-blue-500 text-white  px-2 min-w-40 py-1 rounded-lg"
              className={` p-2 rounded-lg  flex flex-col max-w-48  ${
                message?.role === "sender"
                  ? "bg-blue-500 text-white"
                  : "bg-gray-200 text-gray-800"
              }`}
            >
              <h2>{message?.message}</h2>
              <h3 className="text-[9px] font-extralight flex justify-end">
                {formatDateTime(message?.created_at)}
              </h3>
            </div>

            <ChatDelete messageId={message?.id} />
          </div>
        ))
      )}
    </div>
  );
}

export default ChatMessages;
